<div *ngIf="initialized">
  <div class="card">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">{{analysisName}}</h5>
     
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body">
        <div style="margin-bottom: 1.5em;">
          <h6 *ngIf="description" class="mb-0">Description: {{description}}</h6>
        </div>

        <div class="text-center" style="max-width: 30em; margin: 0 auto;">
          <embed-video-player [encoded]="encoded" [privateVideo]="encoded" [azureUrl]="videoLink" [size]="'large'"></embed-video-player>
        </div>
      </div>
    </div>
  </div>
</div>
